import debounce from "lodash.debounce";
import { useCallback, useEffect } from "react";

export const useDebounce = <T>(
  action: (...params: T[]) => void,
  delay = 1000,
) => {
  const debouncedCallback = useCallback(debounce(action, delay), [action]);

  useEffect(
    () => () => {
      debouncedCallback.cancel();
    },
    [debouncedCallback],
  );

  return debouncedCallback;
};
